import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { PollDetails, PollVote, PollEdit, PollTokens } from './poll';
import { Panel } from './panel';
import { Landing } from './landing';
import { Layout, routes, PrivateRoute, LoadingScreen, withFirebase } from './shared';
import { getCookie, setCookie } from './utils';
import './App.css';
import { AuthContext } from './shared/auth/AuthContext';

class AppBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      userId: null,
      loading: true,
      authorized: false,
    };
  }

  updateUser = (user, token, refreshToken) => {
    const userId = Array.isArray(user) && user[0] ? user[0].id : (user ? user.id : null);
    this.setState({ user, authorized: !!user, userId, loading: false });

    setCookie('token', user && token ? token : null);
    setCookie('refreshToken', user && refreshToken ? refreshToken : null);
  }

  componentDidMount() {
    const token = getCookie('token');
    const refreshToken = getCookie('refreshToken');

    if (!token || !refreshToken) {
      return this.setState({ loading: false });
    }

    this.setState({ loading: true });

    let refreshTokenResponse;

    this.props.firebase.refreshUserToken(refreshToken)
      .then(response => {
        refreshTokenResponse = response
      })
      .then(() => this.props.firebase.getProfile(refreshTokenResponse.token))
      .then(user => this.updateUser(user, refreshTokenResponse.token, refreshTokenResponse.refreshToken))
      .catch(err => {
        console.error(err);
        this.updateUser(null);
      });

    window.setInterval(() => {
      const currentToken = getCookie('token');
      const currentRefreshToken = getCookie('refreshToken');

      if (!currentToken || !currentRefreshToken) return;

      this.props.firebase.refreshUserToken(currentRefreshToken)
        .then(response => {
          setCookie('token', response.token);
          setCookie('refreshToken', response.refreshToken);
        })
        .catch(err => {
          console.error(err);
          this.updateUser(null);
        });
      }, 3000000)
  }

  render() {
    const { loading, authorized } = this.state
    const value = { ...this.state, updateUser: this.updateUser };

    return (
      <AuthContext.Provider value={value}>
        {
          loading ?
          <LoadingScreen /> :
          <div className="App">
            <BrowserRouter>
              <Layout>
                <Switch>
                  <Route exact path={routes.LANDING} component={Landing} />
                  <Route path={routes.POLL_DETAILS} component={PollDetails} />
                  <Route path={routes.POLL_VOTE} component={PollVote} />
                  <PrivateRoute path={routes.POLL_TOKENS} component={PollTokens} authorized={authorized} />
                  <PrivateRoute path={routes.PANEL} component={Panel} authorized={authorized} />
                  <PrivateRoute path={routes.POLL_EDIT} component={PollEdit} authorized={authorized} />
                  <PrivateRoute path={routes.POLL_CREATE} component={PollEdit} authorized={authorized} />
                  <Redirect to={routes.LANDING} />
                </Switch>
              </Layout>
            </BrowserRouter>
          </div>
        }
      </AuthContext.Provider>
    );
  }

}

export const App = withFirebase(AppBase);
